<div id = "uploadWrapper">
  <button mat-raised-button id = "closeButton" class = "btnHoover" (click) = "handleClosing()">X</button>
  @if (state === 'main') {
    <form [formGroup] = "geoForm">
      <h5 id = "header">{{selText.uploadGeoHeader}}</h5>
      <!--<mat-form-field class = "inputField" appearance="outline">
      <mat-label>Name: </mat-label>
      <input type="text" matInput formControlName = "name" placeholder = "Name"/>
      <mat-hint>Write your name</mat-hint>
      <mat-error *ngIf = "geoForm.get('name').invalid">
        You must enter a name
      </mat-error>
    </mat-form-field> -->
    <!--{{geoForm.get('datum').value}}-->
    <!--<p>currentValue of name: {{geoForm.get('name').value}}</p>-->
    <div id="uploadBox" appDragAndDropFile (fileDropped)="fileFromDragAndDrop($event)">
      <input type = "file" formControlName = "geoFile" id = "inputUploadBox" (change) = "fileFromBrowse($event)">
      <p>{{uploadFileText}}</p>
      @if (fileAdded === true) {
        <div style = "margin-left: 15px; margin-top: 8px;">
          <!--<mat-icon>layers</mat-icon>-->
          <mat-icon style = "color: green;">check_circle_outline</mat-icon>
        </div>
      }
    </div>
    <!--{{geoForm.value | json}}-->
    <!--<button mat-raised-button (click) = "fileDescrib()" >Debug geoFile</button>-->
    <mat-expansion-panel id = "advancedOptions" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{selText.uploadMoreOptions}}
        </mat-panel-title>
        <!--<mat-panel-description>
        These are advanced options
      </mat-panel-description>-->
    </mat-expansion-panel-header>
    <!-- Main content of expansion panel -->
    <mat-form-field class = "inputField" appearance="outline">
      <mat-label>{{selText.pickDatum}}: </mat-label>
      <mat-select formControlName = "datum">
        <mat-option value = "" >{{selText.uploadDontKnow}}</mat-option>
        <mat-option value = "3057">ISN93 - Lambert 1993</mat-option>
        <mat-option value = "5325">ISN2004 - Lambert 2004</mat-option>
        <mat-option value = "8088">ISN2016 - Lambert 2016</mat-option>
        <mat-option value = "4326">WGS 84 (GPS)</mat-option>
        <mat-option value = "3857">WGS 84 / Pseudo-Mercator</mat-option>
      </mat-select>
      <!--<input type = "number" matInput formControlName = "datum" placeholder = "Datum" min="1024" max="32767" />-->
      <!--<mat-hint>Choose a option</mat-hint>
      <mat-error *ngIf = "geoForm.get('datum').invalid">
        You must choose an option
      </mat-error>-->
    </mat-form-field>
  </mat-expansion-panel>
  <button mat-raised-button type = "button" id = "submitButton" class = "btnHoover" (click) = "handleSubmit()">{{selText.uploadSubmit}}</button>
</form>
}

@if (state === 'waiting') {
  <div>
    <div class = "center" style = "margin-top: 50px; margin-bottom: 50px;"> <!-- style="margin-top: 80px; overflow: hidden; width: 500px;" -->
      <mat-spinner diameter = "120"></mat-spinner>
    </div>
  </div>
}

@if (state === 'success') {
  <div id = "successContentArea">
    <div style = "margin-right: 50%; margin-left: 36%; margin-top: 10px;">
      <mat-icon style = "color: green;" id = "successFailIcon">check_circle_outline</mat-icon>
    </div>
    <div class = "center">
      <div class = "successErrorText">
        <h6><!--Your file has been saved to your account and we created a layer from it.
          In order to make the layer visible please visit the layer manager
          and pick your layer that corresponds to the filename of the file you uploaded. -->
          {{selText.uploadSuccessText}}
        </h6>
      </div>
    </div>
    <div class = "centerButtons">
      <button mat-raised-button style="margin-bottom: 0px; color: white;" class = "btnHoover" (click) = "goBack()">{{selText.uploadMoreFiles}}</button>
      <button mat-raised-button style="margin-bottom: 0px; color: white; background-color: forestgreen !important;"
        class = "btnHoover"
      (click) = "goToLayerManager()">{{selText.uploadToLayerManager}}</button>
    </div>
  </div>
}

@if (state === 'error') {
  <div>
    <div style = "margin-right: 50%; margin-left: 36%; margin-top: 10px;">
      <mat-icon style = "color: red;" id = "successFailIcon">error_outline</mat-icon>
    </div>
    <div class = "center">
      <div class = "successErrorText">
        <h6>{{selText.uploadErrorText}}</h6>
      </div>
    </div>
    <div class = "centerButtons">
      <button mat-raised-button style="margin-bottom: 0px; color: white;" class = "btnHoover" (click) = "goBack()">{{selText.goBack}}</button>
    </div>
  </div>
}

</div>


